import { BETA_FEATURES, NAV_ITEMS } from '@/constants';
import { isBetaFeatureEnabled } from '@/data/data-selectors';
import reconciliationIcon from '@iconify/icons-ant-design/reconciliation-outlined';
import { useSelector } from 'react-redux';
import { NavItem } from '../../nav-item';
import { useVerticalBarNavigation } from '../use-vertical-bar-navigation';

export const TaxNavItem = () => {
  const { goToTab, pathname } = useVerticalBarNavigation();
  const enableTaxView = useSelector(isBetaFeatureEnabled(BETA_FEATURES.taxTab));

  if (!enableTaxView) {
    return null;
  }

  return (
    <NavItem
      id="tax"
      icon={reconciliationIcon}
      tooltip="Tax"
      ariaLabel="Go to Tax View"
      isActive={pathname.includes(NAV_ITEMS['tax-reporting'])}
      onClick={() => {
        goToTab(NAV_ITEMS['tax-reporting']);
      }}
    />
  );
};
